import { useSelector } from 'react-redux';
import type { RoleName } from '../constants/roles';
import { RootState } from '../store';

const useAuth = () => {
    const userRole = useSelector((state: RootState) => state.auth.user?.role?.name);

    const hasRole = (allowedRoles: readonly RoleName[]) => {
        return userRole !== undefined && allowedRoles.includes(userRole);
    };

    return { hasRole };
};

export default useAuth;
